import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function slugify(text: string): string {
  return text
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/(^-|-$)/g, '');
}

export function parseWikiLinks(markdown: string): string {
  return markdown.replace(/\[\[([^\]]+)\]\]/g, (match, pageName) => {
    const slug = slugify(pageName);
    return `[${pageName}](/wiki/${slug})`;
  });
}

export function parseInfoboxes(markdown: string): string {
  return markdown.replace(/:::infobox\n([\s\S]*?):::/g, (match, content) => {
    return `<div class="infobox">\n\n${content.trim()}\n\n</div>`;
  });
}

export function processMarkdown(markdown: string): string {
  let processed = parseWikiLinks(markdown);
  processed = parseInfoboxes(processed);
  return processed;
}
